import OpencareAnalytics from '@opencare/analytics';
import React, { useMemo } from 'react';

import { useEffectOnce } from 'utils/customHooks/useEffectOnce';
import { JsxUtils } from 'utils/JsxUtils';
import Logger from 'utils/Logger';

import { InsuranceBlockContentWrapper, InsuranceBlockDescription, InsuranceBlockGraphic, InsuranceBlockTitle, InsuranceBlockWrapper } from './styled-components';

const analytics = new OpencareAnalytics();

export enum InsuranceBlockType {
  SOCIAL_ASSISTANCE = 'SOCIAL_ASSISTANCE',
}

const CONTENT_BLOCK_TYPE_MAP = {
  [InsuranceBlockType.SOCIAL_ASSISTANCE]: {
    title: "We're sorry, but we can't book with this plan",
    descriptionLines: [
      "Opencare doesn't book appointments for Medicaid, Medicare Advantage, CHIP, TRICARE, or other government dental plans.",
      'Please call the member services number on the back of your insurance card to find a dentist who takes your plan.',
    ],
  },
} as const satisfies Record<InsuranceBlockType, { title: string; descriptionLines: string[]; }>;

const getContentForBlockType = (type: InsuranceBlockType) => {
  const content = CONTENT_BLOCK_TYPE_MAP[type];

  if (!content) {
    Logger.error(`No content found for checkout insurance block type: ${type}`);
    return null;
  }

  return content;
};

type InsuranceBlockScreenProps = {
  type: InsuranceBlockType;
};
export const InsuranceBlockScreen = ({ type }: InsuranceBlockScreenProps) => {
  useEffectOnce(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-insurance-information',
      name: `insurance-block-${type}`,
    });
  });

  const content = useMemo(() => getContentForBlockType(type), [type]);
  if (!content) {
    return null;
  }

  const { title, descriptionLines } = content;

  return (
    <InsuranceBlockWrapper>
      <InsuranceBlockGraphic />

      <InsuranceBlockContentWrapper>
        <InsuranceBlockTitle>{title}</InsuranceBlockTitle>
        <InsuranceBlockDescription>
          {JsxUtils.joinElements(descriptionLines, (index) => (
            <React.Fragment key={index}>
              <br /><br />
            </React.Fragment>
          ))}
        </InsuranceBlockDescription>
      </InsuranceBlockContentWrapper>
    </InsuranceBlockWrapper>
  );
};
